import React from 'react';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


const FindUs = () => {
  return (
    <div className='app__findUs app__bg app__wrapper section__padding'>
      <div className='app__findUs-content app__wrapper_info' >
        <SubHeading title='Contact' />
        <h1 className='app__findUs-heading headtext__cormorant' >Find Us</h1>
        <div className='app__wrapper-content' >
          <p className='p__opensans' >4, Oyemuwa Street, NAF Valley, Asokoro, <br /> Abuja, Nigeria.</p>
          <p className='p__cormorant' >Opening Hours</p>
          <p className='p__opensans' >Mon - Fri: 10:00 am - 02:00 am</p>
          <p className='p__opensans' >Sat - Sun: 10:00 am - 03:00 am</p>
        </div>
        <button type="button" className="custom__button" >Visit Us</button>
      </div>
      <div className='app__findUs-img app__wrapper_img' >
        <LazyLoadImage src={images.findus} alt="findus" effect='blur' />
      </div>
    </div>
  );
} 

export default FindUs;
